import { authConstants } from '../constants/actionTypes'
import { errorMessages, errorCodes } from '../constants/errors'
import { SEND_ACCESS_CODE_ERROR_MESSAGE } from '../constants/messages'
import * as authService from '../services/authenticationService'
import { alertError, alertSuccess, alertClear } from './alertActions'

export const loginPageRequest = () => ({
  type: authConstants.LOGIN_LOAD,
 })

const requestLogin = () => ({
  type: authConstants.LOGIN_REQUEST,
})

const receiveLoginSuccess = (data) => ({
  type: authConstants.LOGIN_SUCCESS,
  data,
})

export const receiveConsultantLoginSuccess = (opportunityId) => ({
  type: authConstants.CONSULTANT_LOGIN_SUCCESS,
  opportunityId,
})

const receiveLoginError = (errorMessage) => ({
  type: authConstants.LOGIN_ERROR,
  errorMessage,
})

const requestAccessCode = (authenticationMethod) => ({
  type: authConstants.ACCESS_CODE_REQUEST,
  authenticationMethod,
})

const requestAccessCodeSuccess = () => ({
  type: authConstants.ACCESS_CODE_REQUEST_SUCCESS,
})

const requestAccessCodeError = (errorMessage) => ({
  type: authConstants.ACCESS_CODE_REQUEST_ERROR,
  errorMessage,
})

export function logout() {
  authService.logout()
  return { type: authConstants.LOGOUT }
}

export function login(
  opportunityId,
  accessCode,
  history,
  token,
  isAtSettlement
) {
  return (dispatch) => {
    dispatch(requestLogin())
    //const history = useHistory()
    return authService
      .validateAccessCode(opportunityId, accessCode, token)
      .then(
        (data) => {
          dispatch(receiveLoginSuccess(data))
          history.push(isAtSettlement ? '/settlements' : '/home')
          dispatch(alertClear())
        },
        (error) => {
          dispatch(receiveLoginError(error))

          let errorCode = null
          let errors = null

          if (error) {
            if (error.indexOf('expired') > -1) {
              errorCode = errorCodes.EXPIRED_ACCESS_CODE
            } else if (error.indexOf('invalid') > -1) {
              errorCode = errorCodes.INVALID_ACCESS_CODE
            }
          }

          if (errorCode) {
            errors = {
              errorCode,
              messages: errorMessages[errorCode],
            }
          }

          dispatch(alertError(error, errors))
        }
      )
  }
}

export function sendAccessCode(opportunityId, authenticationMethod, token) {
  return (dispatch) => {
    dispatch(requestAccessCode(authenticationMethod))
    return authService
      .requestAccessCode(opportunityId, authenticationMethod, token)
      .then(
        (data) => {
          dispatch(requestAccessCodeSuccess(data))
          dispatch(alertSuccess('Access code has been sent successfully :)'))
        },
        (error) => {
          error = SEND_ACCESS_CODE_ERROR_MESSAGE
          dispatch(requestAccessCodeError(error))
          return Promise.reject(error)
        }
      )
  }
}
